import { mtFetch, type FetchResult } from "./mtFetch";
import type {
  CreateDraftRequest,
  TranslationDraftResponse,
  TranslationDraftsList,
  UpdateDraftRequest,
} from "./types";

export type ListDraftsFilters = {
  owner?: string;
  status?: string;
  limit?: number;
  offset?: number;
};

export function listDrafts(
  filters: ListDraftsFilters = {},
): Promise<FetchResult<TranslationDraftsList>> {
  return mtFetch<TranslationDraftsList>("/v1/translation-drafts", {
    query: filters,
  });
}

export type ListMyDraftsFilters = {
  status?: string;
  include_discarded?: boolean;
  limit?: number;
  offset?: number;
};

/** Черновики текущего пользователя (owner форсится бэкендом из токена). */
export function listMyDrafts(
  filters: ListMyDraftsFilters = {},
): Promise<FetchResult<TranslationDraftsList>> {
  return mtFetch<TranslationDraftsList>("/v1/translation-drafts/mine", {
    query: filters,
  });
}

export function getDraft(
  draftId: string,
): Promise<FetchResult<TranslationDraftResponse>> {
  return mtFetch<TranslationDraftResponse>(
    `/v1/translation-drafts/${encodeURIComponent(draftId)}`,
  );
}

export function createDraft(
  body: CreateDraftRequest,
): Promise<FetchResult<TranslationDraftResponse>> {
  return mtFetch<TranslationDraftResponse>("/v1/translation-drafts", {
    method: "POST",
    body,
  });
}

export function updateDraft(
  draftId: string,
  body: UpdateDraftRequest,
): Promise<FetchResult<TranslationDraftResponse>> {
  return mtFetch<TranslationDraftResponse>(
    `/v1/translation-drafts/${encodeURIComponent(draftId)}`,
    { method: "PUT", body },
  );
}

export function deleteDraft(
  draftId: string,
): Promise<FetchResult<TranslationDraftResponse>> {
  // Backend returns the soft-deleted (status=discarded) draft.
  return mtFetch<TranslationDraftResponse>(
    `/v1/translation-drafts/${encodeURIComponent(draftId)}`,
    { method: "DELETE" },
  );
}

export interface RetranslateDraftRequest {
  backend: string;
  backend_model?: string;
}

export function retranslateDraft(
  draftId: string,
  body: RetranslateDraftRequest,
): Promise<FetchResult<TranslationDraftResponse>> {
  return mtFetch<TranslationDraftResponse>(
    `/v1/translation-drafts/${encodeURIComponent(draftId)}/retranslate`,
    { method: "POST", body },
  );
}
